import {
    allFetch
} from "../Domain";

/**
 * @description 服務鈴
 */
export const MealServiceBell = (() => {
    /**
     * @description 查詢服務鈴服務項目
     */
    const Read = async function (obj = {
        Plant: '',
        isOpen: '',
        msb_id: ''
    }) {
        return await allFetch('MealServiceBell/Read', obj);
    }
    /**
     * @description 查詢服務鈴服務細目
     */
    const Detail = async function (obj = {
        msb_id: ''
    }) {
        return await allFetch('MealServiceBell/Detail', obj);
    }
    /**
     * @description 查詢服務鈴服務項目
     */
    const Create = async function (obj = {
        Plant: '',
        text: '',
        subtitle: '',
        isOpen: '',
        q_id: ''
    }) {
        return await allFetch('MealServiceBell/Create', obj);
    }
    /**
     * @description 刪除服務鈴服務項目
     */
    const Delete = async function (obj = {
        msb_id: ''
    }) {
        return await allFetch('MealServiceBell/Delete', obj);
    }
    /**
     * @description 修改服務鈴服務項目
     */
    const Update = async function (obj) {
        return await allFetch('MealServiceBell/Update', obj);
    }
    return {
        Read,
        Detail,
        Create,
        Delete,
        Update
    }
})();